// https://app.growthbook.io/features/prcng-338_v1
export const INTRO_PRICING_FLAG_NAME = 'prcng-338_v1'
